export const employeeMenu = [
  {
    name: 'Mi perfil',
    id: 'Perfil',
    route: '/perfil/mi_perfil'
  },

  // {
  // name: 'Editar',
  // id: 'Editar',
  // route: '/perfil/editar'
  // },
  {
    name: 'Mis datos',
    id: 'Datos',
    route: '/perfil/mis_datos'
  },
  {
    name: 'Retenciones',
    id: 'Retenciones',
    route: '/perfil/retenciones',
    rol: 'ROL_ACCESS_RETENTION' // ROLE PROVISIONAL MIENTRAS SE GENERAN Y VALIDAN LOS CERTIFICADOS
  },
  {
    name: 'Formación',
    id: 'Formacion',
    route: '/perfil/formacion'
  },
  {
    name: 'Vales comida',
    id: 'Vales',
    route: '/perfil/tickets'
  },
  {
    name: 'Nóminas',
    id: 'Nominas',
    route: '/perfil/nominas'
  },
  {
    name: 'Configura tu firma de empleado',
    id: 'Firma',
    route: 'https://firmas.atresmedia.com/'
  },
  {
    name: 'Factura Renting',
    id: 'Renting',
    route: 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=renting',
    rol: 'ROLE_ACCESS_RENTING_INVOICE'
  }
];

export const departmentMenu = [
  {
    name: 'Información general',
    id: 'informacion_general',
    route: `/departamento/informacion_general`
  },
  {
    name: 'Documentación',
    id: 'documentacion',
    route: `/departamento/documentos`
  }
];

export const fiscalDataMenu = [
  {
    name: 'DOMICILIO PERSONAL',
    id: 'DomicilioPersonal'
  },
  {
    name: 'DATOS DOMICILIACIÓN BANCARIA',
    id: 'DatosDomBancaria'
  },
  {
    name: 'DATOS IRPF',
    id: 'DatosIRPF'
  },
  {
    name: 'OTROS DATOS',
    id: 'otrosDatos'
  }
];
